exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".graficaGestionAdministrativo .container_gestion .filtrosGestionAdministrativo .col-12{padding:12px 0}.graficaGestionAdministrativo .v-data-table td:last-child{padding:0;min-width:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57c3ec6c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Gestion/gestionAdministrativo/gestionAdministrativo.vue
// module id = 1057
// module chunks = 0